<template>
    <component
        :is="tag"
        v-if="isVisible"
    >
        <slot
            name="default"
        />
        <slot
            name="child"
            :onHide="onHide"
        />
    </component>
</template>

<script lang="ts" setup>
    withDefaults(
        defineProps<{
            tag?: string;
        }>(),
        {
            tag: 'div'
        }
    );

    const isVisible = ref<boolean>(true);

    function onHide(): void {
        isVisible.value = false;
    }
</script>

<style lang="scss"></style>
